export default __webpack_public_path__ + "static/media/vid-holder-the-strip-district.7e08522d.png";